module.exports = __webpack_public_path__ + "static/household-fire-blanket-6ca24bfebb02e2ab64a2bb0c72fc9e44.png";